export const getUniqueTimestamp = () => {
    return +new Date()
}
